import React, { Component }  from 'react';
import Carousel from 'react-bootstrap/Carousel'
import Image1 from '../images/IMG_1974.jpg';
import Image2 from '../images/IMG_1978.jpg';
import Image3 from '../images/IMG_1981.jpg';
import Image4 from '../images/IMG_2121.jpg';
import Image5 from '../images/IMG_2122.jpg';

function ControlledCarousel() {
    const [index, setIndex] = React.useState(0);
  
    const handleSelect = (selectedIndex, e) => {
      setIndex(selectedIndex);
    };
  
    return (
      <Carousel activeIndex={index} onSelect={handleSelect}>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src={Image1}
            alt="First slide"
          />
          <Carousel.Caption>
            <h3>Exterior Painting</h3>
            <p className="d-none d-sm-block">Call us now, for a free exterior painting service quote for your home.</p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src={Image2}
            alt="Second slide"
          />  
          <Carousel.Caption>
            <h3>Roof Repairs</h3>
            <p className="d-none d-sm-block">Leaks everywhere? Call us now and let us repair your roof at an affordable price.</p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src={Image3}
            alt="Third slide"
          />  
          <Carousel.Caption>
            <h3>Interior Remodeling</h3>
            <p className="d-none d-sm-block">Allow us to help. We do the complete job for you... and take care of your furniture too!</p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src={Image4}
            alt="Third slide"
          />
  
          <Carousel.Caption>
            <h3>Commercial Painting</h3>
            <p className="d-none d-sm-block">We have a reputation for great jobs at even better prices. Call us now and find out why!</p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100"
            src={Image5}
            alt="Third slide"
          />
  
          <Carousel.Caption>
            <h3>Home or Commercial Remodeling and Painting</h3>
            <p className="d-none d-sm-block">See how we transform your needs in a relity. Relax and let us help!.</p>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
    );
}

class MyCarousel extends Component {     
    
    render() {
        return (
          <ControlledCarousel />
        )        
    };     
}

export default MyCarousel;